import { render, staticRenderFns } from "./seguimiento.vue?vue&type=template&id=fdd3b266"
import script from "./seguimiento.vue?vue&type=script&lang=js"
export * from "./seguimiento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports